export default {
  appTitle: 'Web de proveedores',
  title: 'Iniciar sesión',
  loginButton: 'Iniciar sesión',
  forgotPasswordButton: 'Restablecer contraseña',
  signIn: {
    button: 'Crear cuenta',
    label: '¿Aún no tienes una cuenta?'
  },
  email: {
    inputLabel: 'Correo electrónico'
  },
  password: {
    inputLabel: 'Contraseña'
  }
}
